/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/array-type */
/* eslint-disable import/order */
import {
  CircularProgress,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { FC, memo, useMemo } from 'react';
import { styles } from '@bvi/admin-panel/feature/manage-list/ui/manage-base-table/style';
import { useTranslation } from 'react-i18next';
import { useGetOrderListQuery } from '@bvi/admin-panel/entities/order/api-slice';
import { selectOrder } from '@bvi/admin-panel/entities/order/selectors';
import { Span } from '@bvi/common-components';
import { IOrderData } from '@bvi/api-interfaces/response/manage-base-data';
import { OrderTableRow } from './order-row';

interface IOrdersTableProperties {
  query: string;
}

const OrdersTableComponent: FC<IOrdersTableProperties> = ({
  query,
}) => {
  const { t } = useTranslation();

  const { data: orderList, isLoading: isOrderLoading } = useGetOrderListQuery(
    undefined,
    {
      selectFromResult: ({ data, isLoading }) => ({
        data: selectOrder(data),
        isLoading,
      }),
    },
  );

  const filteredAndSorted = useMemo(() => {
    const list = query
      ? orderList.filter((s: IOrderData) => {
          const lower = query.toLowerCase();
          return (
            String(s.id).includes(lower) ||
            (s.name?.toLowerCase().includes(lower) ?? false)
          );
        })
      : [...orderList];

    return list.sort((a: IOrderData, b: IOrderData) => {
      const nameA = a.name?.toLowerCase() ?? '';
      const nameB = b.name?.toLowerCase() ?? '';
      return nameA.localeCompare(nameB);
    });
  }, [query, orderList]);

  const tableColumns = [
    {
      title: t('manageBaseTable.table.columns.id'),
      width: '10%',
    },
    {
      title: t('manageBaseTable.table.columns.name'),
      width: '60%',
    },
    {
      title: t('manageBaseTable.table.columns.createdAt'),
      width: '20%',
    },
    {
      width: '70px',
    },
  ];

  return (
    <>
      <TableContainer component={Paper}>
        <Table sx={styles.fixedTable}>
          <TableHead>
            <TableRow>
              {tableColumns.map((column, index) => (
                <TableCell width={column.width} key={index}>
                  {column.title}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {isOrderLoading ? (
              <TableRow>
                <TableCell colSpan={tableColumns.length} align="center">
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <CircularProgress size={24} />
                  </Stack>
                </TableCell>
              </TableRow>
            ) : (
              filteredAndSorted.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={tableColumns.length} align="center">
                    <Span>{t('manageBaseTable.table.results.empty')}</Span>
                  </TableCell>
                </TableRow>
              ) : (
                filteredAndSorted.map(
                  (order: IOrderData) => (
                    <OrderTableRow
                      order={order}
                      key={order.id}
                    />
                  ),
                )
              )
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export const OrdersTable = memo(OrdersTableComponent);

